<div
  class="partial-times-chip"
  [matTooltip]="'userPartiallyAcceptedForTime' | i18n"
  matTooltipPosition="above">
  {{ partialAcceptTime?.from | formatMilitaryTimeNumber }} -
  {{ partialAcceptTime?.to | formatMilitaryTimeNumber }}
</div>
